export default "__VITE_ASSET__BBh$AHOu__"